import { ArrowUpCircle } from "iconoir-react";

import { createIcon } from "../create-icon";

export const IconArrowUpCircle12Line = createIcon(ArrowUpCircle, 12, "Line");
export const IconArrowUpCircle16Line = createIcon(ArrowUpCircle, 16, "Line");
export const IconArrowUpCircle20Line = createIcon(ArrowUpCircle, 20, "Line");
export const IconArrowUpCircle24Line = createIcon(ArrowUpCircle, 24, "Line");
export const IconArrowUpCircle32Line = createIcon(ArrowUpCircle, 32, "Line");
export const IconArrowUpCircle48Line = createIcon(ArrowUpCircle, 48, "Line");
export const IconArrowUpCircle64Line = createIcon(ArrowUpCircle, 64, "Line");
